(function webpackUniversalModuleDefinition(root, factory) {
  if (typeof exports === 'object' && typeof module === 'object') module.exports = factory();else if (typeof define === 'function' && define.amd) define([], factory);else if (typeof exports === 'object') exports["messageBus"] = factory();else root["messageBus"] = factory();
})(this, function () {
  return (
    /******/
    function (modules) {
      // webpackBootstrap

      /******/
      // The module cache

      /******/
      var installedModules = {};
      /******/

      /******/
      // The require function

      /******/

      function __webpack_require__(moduleId) {
        /******/

        /******/
        // Check if module is in cache

        /******/
        if (installedModules[moduleId])
          /******/
          return installedModules[moduleId].exports;
        /******/

        /******/
        // Create a new module (and put it into the cache)

        /******/

        var module = installedModules[moduleId] = {
          /******/
          exports: {},

          /******/
          id: moduleId,

          /******/
          loaded: false
          /******/

        };
        /******/

        /******/
        // Execute the module function

        /******/

        modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
        /******/

        /******/
        // Flag the module as loaded

        /******/

        module.loaded = true;
        /******/

        /******/
        // Return the exports of the module

        /******/

        return module.exports;
        /******/
      }
      /******/

      /******/

      /******/
      // expose the modules object (__webpack_modules__)

      /******/


      __webpack_require__.m = modules;
      /******/

      /******/
      // expose the module cache

      /******/

      __webpack_require__.c = installedModules;
      /******/

      /******/
      // __webpack_public_path__

      /******/

      __webpack_require__.p = "";
      /******/

      /******/
      // Load entry module and return exports

      /******/

      return __webpack_require__(0);
      /******/
    }(
    /************************************************************************/

    /******/
    [
    /* 0 */

    /*!**********************!*\
      !*** ./src/index.ts ***!
      \**********************/

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      var messageBus_1 = __webpack_require__(
      /*! ./messageBus */
      1);

      var angularMessageBus_1 = __webpack_require__(
      /*! ./angularMessageBus */
      5); // Only create the angular "messageBus" service if angular is present


      if (window) {
        var a = window['angular'];

        if (a) {
          angularMessageBus_1.createMessageBusService(a);
        }
      }

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = messageBus_1.default;
      /***/
    },
    /* 1 */

    /*!***************************!*\
      !*** ./src/messageBus.ts ***!
      \***************************/

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      var _ = __webpack_require__(
      /*! ../lib/lodash.custom.min.js */
      2);

      function messageBusFactory() {
        if (!window) {
          // Server-Side-Rendering: no window; just return a No-Op MessageBus
          var noOpMessageBus = {
            domains: [],
            listen: function listen() {},
            send: function send() {},
            ask: function ask() {}
          };
          return noOpMessageBus;
        }

        var location = window.location;
        var myDomain = location.protocol + "//" + location.hostname + (location.port ? ":" + location.port : '');
        var messageBusListeners = [];
        var messageIdCounter = 0;
        var responseMap = {}; //<IResponseListener>

        window.addEventListener('message', onWindowMessage);
        var messageBus = {
          domains: [],
          listen: listen,
          send: send,
          ask: ask,
          _testClearListeners: _testClearListeners
        };
        return messageBus;

        function _testClearListeners() {
          messageBusListeners = [];
        }

        function listen(config, callback) {
          validateBaseConfig(config, 'messageBus.listen');

          var existingListeners = _.where(messageBusListeners, {
            to: config.to,
            from: config.from,
            task: config.task
          });

          if (existingListeners && existingListeners.length) {
            console.warn('duplicate listener created: ' + JSON.stringify(config));
          }

          var listener = {
            to: config.to,
            from: config.from,
            task: config.task,
            callback: callback
          };
          messageBusListeners.push(listener);
        }

        function send(target, config) {
          validateBaseConfig(config, 'messageBus.send');
          var id = ++messageIdCounter;

          var message = _.extend(config, {
            id: id,
            expectResponse: false
          }); //console.log('send #', id);


          target.postMessage(message, config.targetOrigin || '*');
        }

        function ask(target, config, successCallback, errorCallback) {
          validateBaseConfig(config, 'messageBus.ask');
          var id = ++messageIdCounter;

          var message = _.extend(config, {
            id: id,
            expectResponse: true
          });

          responseMap[id] = {
            config: config,
            successCallback: successCallback,
            errorCallback: errorCallback
          };
          var DEFAULT_TIMEOUT = 8000;
          var timeout = _.isFinite(config.timeout) ? config.timeout : DEFAULT_TIMEOUT;
          setTimeout(function () {
            var responseListener = responseMap[id];
            if (!responseListener) return;
            console.warn('Response #' + id + ' timed out.');
            delete responseMap[id];

            if (responseListener.errorCallback) {
              responseListener.errorCallback(new Error('timed out'));
            }
          }, timeout); //console.log('ask #', id);

          target.postMessage(message, config.targetOrigin || '*');
        }

        function validateBaseConfig(config, caller) {
          if (!config) throw new Error(caller + ' called without any config!');
          if (!config.to || !_.isString(config.to)) throw new Error(caller + ' called without a valid "to" id.');
          if (!config.from || !_.isString(config.from)) throw new Error(caller + ' called without a valid "from" id.');
          if (!config.task || !_.isString(config.task)) throw new Error(caller + ' called without a valid "task" id.');
          if (config.task == 'response') throw new Error(caller + ' called with an invalid "task" id of "response".');
        }

        function onWindowMessage(windowMessage) {
          if (!windowMessage || !windowMessage.data || !windowMessage.origin) {
            //throw new Error('received invalid window message');
            return; //ignore unknown message
          }

          if (windowMessage.origin !== myDomain && !_.findWhere(messageBus.domains, windowMessage.origin) && !_.findWhere(messageBus.domains, '*')) {
            throw new Error('received message from ' + windowMessage.origin + ' but origin is not in domains list: ' + JSON.stringify(messageBus.domains));
          }

          var data = windowMessage.data;
          var message = {
            id: data.id,
            responseId: data.responseId,
            expectResponse: data.expectResponse,
            to: data.to,
            from: data.from,
            task: data.task,
            data: data.data,
            source: windowMessage.source
          };

          if (message.task == 'response') {
            if (!_.isFinite(message.responseId)) {
              throw new Error('received response with invalid responseId');
            }

            var responseListener = responseMap[message.responseId];

            if (responseListener) {
              delete responseMap[message.responseId];
              responseListener.successCallback(message);
            } else {
              console.warn('Received response #' + message.responseId + ' but no handler was found. It may have timed out.');
            }

            return;
          }

          if (!_.isFinite(message.id) || !_.isString(message.from) || !_.isString(message.to) || !_.isString(message.task)) {
            // throw new Error('received message with invalid id/from/to/task');
            return; //ignore unknown message (possible source react-devtools-detector)
          }

          if (message.to == '*' || message.from == '*' || message.task == '*') {
            throw new Error('received message sent with wildcards');
          }

          var listeners = _.filter(messageBusListeners, function (listener) {
            var toMatch = listener.to == message.to || listener.to == '*';
            var fromMatch = listener.from == message.from || listener.from == '*';
            var taskMatch = listener.task == message.task || listener.task == '*'; //console.log('onWindowMessage match:', toMatch, fromMatch, taskMatch);

            return toMatch && fromMatch && taskMatch;
          }); //console.log('listeners', listeners);


          _.each(listeners, function (listener) {
            if (message.expectResponse) {
              var respondCallback = function respondCallback(target, data, targetOrigin) {
                var id = ++messageIdCounter;
                var responseMessage = {
                  id: id,
                  responseId: message.id,
                  expectResponse: null,
                  to: null,
                  from: null,
                  task: 'response',
                  data: data
                }; //console.log('response #' + id + ' for #', message.id);

                target.postMessage(responseMessage, targetOrigin || '*');
              }; //console.log('callback respondCallback for #', message.id);


              try {
                listener.callback(message, respondCallback);
              } catch (e) {
                console.error('error in callback on task ' + message.task, e);
              }
            } else {
              //console.log('callback simple for #', message.id);
              try {
                listener.callback(message);
              } catch (e) {
                console.error('error in callback on task ' + message.task, e);
              }
            }
          });
        }
      }

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = messageBusFactory();
      /***/
    },
    /* 2 */

    /*!**********************************!*\
      !*** ./lib/lodash.custom.min.js ***!
      \**********************************/

    /***/
    function (module, exports, __webpack_require__) {
      var __WEBPACK_AMD_DEFINE_RESULT__;
      /* WEBPACK VAR INJECTION */


      (function (module, global) {
        /**
        * @license
        * lodash 3.10.1 (Custom Build) lodash.com/license | Underscore.js 1.8.3 underscorejs.org/LICENSE
        * Build: `lodash include="find,where,findWhere,each,filter,assign,isString,isFinite" exports="amd"`
        */
        ;
        (function () {
          function C(a) {
            return !!a && typeof a == "object";
          }

          function k() {}

          function Va(a, b) {
            var c = -1,
                d = a.length;

            for (b || (b = Array(d)); ++c < d;) {
              b[c] = a[c];
            }

            return b;
          }

          function ga(a, b) {
            for (var c = -1, d = a.length; ++c < d && false !== b(a[c], c, a);) {
              ;
            }

            return a;
          }

          function Wa(a, b) {
            for (var c = -1, d = a.length, e = -1, f = []; ++c < d;) {
              var g = a[c];
              b(g, c, a) && (f[++e] = g);
            }

            return f;
          }

          function Xa(a, b) {
            for (var c = -1, d = a.length; ++c < d;) {
              if (b(a[c], c, a)) return true;
            }

            return false;
          }

          function ta(a, b) {
            var c;
            if (null == b) c = a;else {
              c = D(b);
              var d = a;
              d || (d = {});

              for (var e = -1, f = c.length; ++e < f;) {
                var g = c[e];
                d[g] = b[g];
              }

              c = d;
            }
            return c;
          }

          function ua(a, b, c) {
            var d = typeof a;
            return "function" == d ? b === m ? a : ha(a, b, c) : null == a ? ia : "object" == d ? P(a) : b === m ? va(a) : Ya(a, b);
          }

          function wa(a, b, c, d, e, f, g) {
            var h;
            c && (h = e ? c(a, d, e) : c(a));
            if (h !== m) return h;
            if (!x(a)) return a;

            if (d = t(a)) {
              if (h = Za(a), !b) return Va(a, h);
            } else {
              var r = A.call(a),
                  n = r == H;

              if (r == u || r == I || n && !e) {
                if (Q(a)) return e ? a : {};
                h = $a(n ? {} : a);
                if (!b) return ta(h, a);
              } else return p[r] ? ab(a, r, b) : e ? a : {};
            }

            f || (f = []);
            g || (g = []);

            for (e = f.length; e--;) {
              if (f[e] == a) return g[e];
            }

            f.push(a);
            g.push(h);
            (d ? ga : xa)(a, function (d, e) {
              h[e] = wa(d, b, c, e, a, f, g);
            });
            return h;
          }

          function bb(a, b) {
            var c = [];
            ja(a, function (a, e, f) {
              b(a, e, f) && c.push(a);
            });
            return c;
          }

          function cb(a, b, c) {
            var d;
            c(a, function (a, c, g) {
              if (b(a, c, g)) return d = a, false;
            });
            return d;
          }

          function xa(a, b) {
            return db(a, b, D);
          }

          function ya(a, b, c) {
            if (null != a) {
              a = y(a);
              c !== m && c in a && (b = [c]);
              c = 0;

              for (var d = b.length; null != a && c < d;) {
                a = y(a)[b[c++]];
              }

              return c && c == d ? a : m;
            }
          }

          function ka(a, b, c, d, e, f) {
            if (a === b) a = true;else if (null == a || null == b || !x(a) && !C(b)) a = a !== a && b !== b;else a: {
              var g = ka,
                  h = t(a),
                  r = t(b),
                  n = F,
                  l = F;
              h || (n = A.call(a), n == I ? n = u : n != u && (h = la(a)));
              r || (l = A.call(b), l == I ? l = u : l != u && la(b));
              var k = n == u && !Q(a),
                  r = l == u && !Q(b),
                  l = n == l;

              if (!l || h || k) {
                if (!d && (n = k && v.call(a, "__wrapped__"), r = r && v.call(b, "__wrapped__"), n || r)) {
                  a = g(n ? a.value() : a, r ? b.value() : b, c, d, e, f);
                  break a;
                }

                if (l) {
                  e || (e = []);
                  f || (f = []);

                  for (n = e.length; n--;) {
                    if (e[n] == a) {
                      a = f[n] == b;
                      break a;
                    }
                  }

                  e.push(a);
                  f.push(b);
                  a = (h ? eb : fb)(a, b, g, c, d, e, f);
                  e.pop();
                  f.pop();
                } else a = false;
              } else a = gb(a, b, n);
            }
            return a;
          }

          function hb(a, b) {
            var c = b.length,
                d = c;
            if (null == a) return !d;

            for (a = y(a); c--;) {
              var e = b[c];
              if (e[2] ? e[1] !== a[e[0]] : !(e[0] in a)) return false;
            }

            for (; ++c < d;) {
              var e = b[c],
                  f = e[0],
                  g = a[f],
                  h = e[1];

              if (e[2]) {
                if (g === m && !(f in a)) return false;
              } else if (e = m, e === m ? !ka(h, g, void 0, true) : !e) return false;
            }

            return true;
          }

          function P(a) {
            var b = ib(a);

            if (1 == b.length && b[0][2]) {
              var c = b[0][0],
                  d = b[0][1];
              return function (a) {
                if (null == a) return false;
                a = y(a);
                return a[c] === d && (d !== m || c in a);
              };
            }

            return function (a) {
              return hb(a, b);
            };
          }

          function Ya(a, b) {
            var c = t(a),
                d = za(a) && b === b && !x(b),
                e = a + "";
            a = Aa(a);
            return function (f) {
              if (null == f) return false;
              var g = e;
              f = y(f);

              if (!(!c && d || g in f)) {
                if (1 != a.length) {
                  var g = a,
                      h = 0,
                      r = -1,
                      k = -1,
                      l = g.length,
                      h = null == h ? 0 : +h || 0;
                  0 > h && (h = -h > l ? 0 : l + h);
                  r = r === m || r > l ? l : +r || 0;
                  0 > r && (r += l);
                  l = h > r ? 0 : r - h >>> 0;
                  h >>>= 0;

                  for (r = Array(l); ++k < l;) {
                    r[k] = g[k + h];
                  }

                  f = ya(f, r);
                }

                if (null == f) return false;
                g = Ba(a);
                f = y(f);
              }

              return f[g] === b ? b !== m || g in f : ka(b, f[g], m, true);
            };
          }

          function Ca(a) {
            return function (b) {
              return null == b ? m : y(b)[a];
            };
          }

          function jb(a) {
            var b = a + "";
            a = Aa(a);
            return function (c) {
              return ya(c, a, b);
            };
          }

          function ha(a, b, c) {
            if (typeof a != "function") return ia;
            if (b === m) return a;

            switch (c) {
              case 1:
                return function (c) {
                  return a.call(b, c);
                };

              case 3:
                return function (c, e, f) {
                  return a.call(b, c, e, f);
                };

              case 4:
                return function (c, e, f, g) {
                  return a.call(b, c, e, f, g);
                };

              case 5:
                return function (c, e, f, g, h) {
                  return a.call(b, c, e, f, g, h);
                };
            }

            return function () {
              return a.apply(b, arguments);
            };
          }

          function Da(a) {
            var b = new kb(a.byteLength);
            new ma(b).set(new ma(a));
            return b;
          }

          function eb(a, b, c, d, e, f, g) {
            var h = -1,
                k = a.length,
                n = b.length;
            if (k != n && !(e && n > k)) return false;

            for (; ++h < k;) {
              var l = a[h],
                  n = b[h],
                  p = d ? d(e ? n : l, e ? l : n, h) : m;

              if (p !== m) {
                if (p) continue;
                return false;
              }

              if (e) {
                if (!Xa(b, function (a) {
                  return l === a || c(l, a, d, e, f, g);
                })) return false;
              } else if (l !== n && !c(l, n, d, e, f, g)) return false;
            }

            return true;
          }

          function gb(a, b, c) {
            switch (c) {
              case J:
              case K:
                return +a == +b;

              case L:
                return a.name == b.name && a.message == b.message;

              case M:
                return a != +a ? b != +b : a == +b;

              case N:
              case E:
                return a == b + "";
            }

            return false;
          }

          function fb(a, b, c, d, e, f, g) {
            var h = D(a),
                k = h.length,
                n = D(b).length;
            if (k != n && !e) return false;

            for (n = k; n--;) {
              var l = h[n];
              if (!(e ? l in b : v.call(b, l))) return false;
            }

            for (var p = e; ++n < k;) {
              var l = h[n],
                  q = a[l],
                  s = b[l],
                  t = d ? d(e ? s : q, e ? q : s, l) : m;
              if (t === m ? !c(q, s, d, e, f, g) : !t) return false;
              p || (p = "constructor" == l);
            }

            return p || (c = a.constructor, d = b.constructor, !(c != d && "constructor" in a && "constructor" in b) || typeof c == "function" && c instanceof c && typeof d == "function" && d instanceof d) ? true : false;
          }

          function Ea(a, b) {
            var c = k.callback || R,
                c = c === R ? ua : c;
            return c(a, b, 3);
          }

          function ib(a) {
            a = Fa(a);

            for (var b = a.length; b--;) {
              var c = a[b][1];
              a[b][2] = c === c && !x(c);
            }

            return a;
          }

          function Ga(a, b) {
            var c = null == a ? m : a[b];
            return Ha(c) ? c : m;
          }

          function Za(a) {
            var b = a.length,
                c = new a.constructor(b);
            b && "string" == typeof a[0] && v.call(a, "index") && (c.index = a.index, c.input = a.input);
            return c;
          }

          function $a(a) {
            a = a.constructor;
            typeof a == "function" && a instanceof a || (a = Object);
            return new a();
          }

          function ab(a, b, c) {
            var d = a.constructor;

            switch (b) {
              case na:
                return Da(a);

              case J:
              case K:
                return new d(+a);

              case S:
              case T:
              case U:
              case V:
              case W:
              case X:
              case Y:
              case Z:
              case $:
                return d instanceof d && (d = z[b]), b = a.buffer, new d(c ? Da(b) : b, a.byteOffset, a.length);

              case M:
              case E:
                return new d(a);

              case N:
                var e = new d(a.source, lb.exec(a));
                e.lastIndex = a.lastIndex;
            }

            return e;
          }

          function oa(a, b) {
            a = typeof a == "number" || mb.test(a) ? +a : -1;
            b = null == b ? Ia : b;
            return -1 < a && 0 == a % 1 && a < b;
          }

          function Ja(a, b, c) {
            if (!x(c)) return false;
            var d = typeof b;
            return ("number" == d ? null != c && B(aa(c)) && oa(b, c.length) : "string" == d && b in c) ? (b = c[b], a === a ? a === b : b !== b) : false;
          }

          function za(a) {
            var b = typeof a;
            return "string" == b && nb.test(a) || "number" == b ? true : t(a) ? false : !ob.test(a) || false;
          }

          function B(a) {
            return typeof a == "number" && -1 < a && 0 == a % 1 && a <= Ia;
          }

          function Ka(a) {
            for (var b = La(a), c = b.length, d = c && a.length, e = !!d && B(d) && (t(a) || pa(a) || ba(a)), f = -1, g = []; ++f < c;) {
              var h = b[f];
              (e && oa(h, d) || v.call(a, h)) && g.push(h);
            }

            return g;
          }

          function y(a) {
            if (k.support.unindexedChars && ba(a)) {
              for (var b = -1, c = a.length, d = Object(a); ++b < c;) {
                d[b] = a.charAt(b);
              }

              return d;
            }

            return x(a) ? a : Object(a);
          }

          function Aa(a) {
            if (t(a)) return a;
            var b = [];
            (null == a ? "" : a + "").replace(pb, function (a, d, e, f) {
              b.push(e ? f.replace(qb, "$1") : d || a);
            });
            return b;
          }

          function Ba(a) {
            var b = a ? a.length : 0;
            return b ? a[b - 1] : m;
          }

          function qa(a, b, c) {
            var d = t(a) ? Wa : bb;
            b = Ea(b, c);
            return d(a, b);
          }

          function Ma(a, b) {
            if (typeof a != "function") throw new TypeError(rb);
            b = Na(b === m ? a.length - 1 : +b || 0, 0);
            return function () {
              for (var c = arguments, d = -1, e = Na(c.length - b, 0), f = Array(e); ++d < e;) {
                f[d] = c[b + d];
              }

              switch (b) {
                case 0:
                  return a.call(this, f);

                case 1:
                  return a.call(this, c[0], f);

                case 2:
                  return a.call(this, c[0], c[1], f);
              }

              e = Array(b + 1);

              for (d = -1; ++d < b;) {
                e[d] = c[d];
              }

              e[b] = f;
              return a.apply(this, e);
            };
          }

          function pa(a) {
            return C(a) && null != a && B(aa(a)) && v.call(a, "callee") && !ca.call(a, "callee");
          }

          function da(a) {
            return x(a) && A.call(a) == H;
          }

          function x(a) {
            var b = typeof a;
            return !!a && ("object" == b || "function" == b);
          }

          function Ha(a) {
            return null == a ? false : da(a) ? Oa.test(Pa.call(a)) : C(a) && (Q(a) ? Oa : sb).test(a);
          }

          function ba(a) {
            return typeof a == "string" || C(a) && A.call(a) == E;
          }

          function la(a) {
            return C(a) && B(a.length) && !!q[A.call(a)];
          }

          function La(a) {
            if (null == a) return [];
            x(a) || (a = Object(a));

            for (var b = a.length, c = k.support, b = b && B(b) && (t(a) || pa(a) || ba(a)) && b || 0, d = a.constructor, e = -1, d = da(d) && d.prototype || G, f = d === a, g = Array(b), h = 0 < b, m = c.enumErrorProps && (a === ea || a instanceof Error), n = c.enumPrototypes && da(a); ++e < b;) {
              g[e] = e + "";
            }

            for (var l in a) {
              n && "prototype" == l || m && ("message" == l || "name" == l) || h && oa(l, b) || "constructor" == l && (f || !v.call(a, l)) || g.push(l);
            }

            if (c.nonEnumShadows && a !== G) for (b = a === tb ? E : a === ea ? L : A.call(a), c = s[b] || s[u], b == u && (d = G), b = ra.length; b--;) {
              l = ra[b], e = c[l], f && e || (e ? !v.call(a, l) : a[l] === d[l]) || g.push(l);
            }
            return g;
          }

          function Fa(a) {
            a = y(a);

            for (var b = -1, c = D(a), d = c.length, e = Array(d); ++b < d;) {
              var f = c[b];
              e[b] = [f, a[f]];
            }

            return e;
          }

          function R(a, b, c) {
            c && Ja(a, b, c) && (b = m);
            return C(a) ? Qa(a) : ua(a, b);
          }

          function ia(a) {
            return a;
          }

          function Qa(a) {
            return P(wa(a, true));
          }

          function va(a) {
            return za(a) ? Ca(a) : jb(a);
          }

          var m,
              rb = "Expected a function",
              I = "[object Arguments]",
              F = "[object Array]",
              J = "[object Boolean]",
              K = "[object Date]",
              L = "[object Error]",
              H = "[object Function]",
              M = "[object Number]",
              u = "[object Object]",
              N = "[object RegExp]",
              E = "[object String]",
              na = "[object ArrayBuffer]",
              S = "[object Float32Array]",
              T = "[object Float64Array]",
              U = "[object Int8Array]",
              V = "[object Int16Array]",
              W = "[object Int32Array]",
              X = "[object Uint8Array]",
              Y = "[object Uint8ClampedArray]",
              Z = "[object Uint16Array]",
              $ = "[object Uint32Array]",
              ob = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\n\\]|\\.)*?\1)\]/,
              nb = /^\w*$/,
              pb = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\n\\]|\\.)*?)\2)\]/g,
              qb = /\\(\\)?/g,
              lb = /\w*$/,
              sb = /^\[object .+?Constructor\]$/,
              mb = /^\d+$/,
              ra = "constructor hasOwnProperty isPrototypeOf propertyIsEnumerable toLocaleString toString valueOf".split(" "),
              q = {};
          q[S] = q[T] = q[U] = q[V] = q[W] = q[X] = q[Y] = q[Z] = q[$] = true;
          q[I] = q[F] = q[na] = q[J] = q[K] = q[L] = q[H] = q["[object Map]"] = q[M] = q[u] = q[N] = q["[object Set]"] = q[E] = q["[object WeakMap]"] = false;
          var p = {};
          p[I] = p[F] = p[na] = p[J] = p[K] = p[S] = p[T] = p[U] = p[V] = p[W] = p[M] = p[u] = p[N] = p[E] = p[X] = p[Y] = p[Z] = p[$] = true;
          p[L] = p[H] = p["[object Map]"] = p["[object Set]"] = p["[object WeakMap]"] = false;

          var fa = {
            "function": true,
            object: true
          },
              ub = fa[typeof module] && module && !module.nodeType && module,
              vb = fa[typeof self] && self && self.Object && self,
              Ra = fa[typeof window] && window && window.Object && window,
              w = fa[typeof exports] && exports && !exports.nodeType && exports && ub && typeof global == "object" && global && global.Object && global || Ra !== (this && this.window) && Ra || vb || this,
              Q = function () {
            try {
              Object({
                toString: 0
              } + "");
            } catch (a) {
              return function () {
                return false;
              };
            }

            return function (a) {
              return typeof a.toString != "function" && typeof (a + "") == "string";
            };
          }(),
              wb = Array.prototype,
              ea = Error.prototype,
              G = Object.prototype,
              tb = String.prototype,
              Pa = Function.prototype.toString,
              v = G.hasOwnProperty,
              A = G.toString,
              Oa = RegExp("^" + Pa.call(v).replace(/[\\^$.*+?()[\]{}|]/g, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"),
              kb = w.ArrayBuffer,
              ca = G.propertyIsEnumerable,
              xb = wb.splice,
              ma = w.Uint8Array,
              yb = Ga(Array, "isArray"),
              zb = w.isFinite,
              Sa = Ga(Object, "keys"),
              Na = Math.max,
              Ia = 9007199254740991,
              z = {};

          z[S] = w.Float32Array;
          z[T] = w.Float64Array;
          z[U] = w.Int8Array;
          z[V] = w.Int16Array;
          z[W] = w.Int32Array;
          z[X] = ma;
          z[Y] = w.Uint8ClampedArray;
          z[Z] = w.Uint16Array;
          z[$] = w.Uint32Array;
          var s = {};
          s[F] = s[K] = s[M] = {
            constructor: true,
            toLocaleString: true,
            toString: true,
            valueOf: true
          };
          s[J] = s[E] = {
            constructor: true,
            toString: true,
            valueOf: true
          };
          s[L] = s[H] = s[N] = {
            constructor: true,
            toString: true
          };
          s[u] = {
            constructor: true
          };
          ga(ra, function (a) {
            for (var b in s) {
              if (v.call(s, b)) {
                var c = s[b];
                c[a] = v.call(c, a);
              }
            }
          });
          var O = k.support = {};

          (function (a) {
            function b() {
              this.x = a;
            }

            var c = {
              0: a,
              length: a
            },
                d = [];
            b.prototype = {
              valueOf: a,
              y: a
            };

            for (var e in new b()) {
              d.push(e);
            }

            O.enumErrorProps = ca.call(ea, "message") || ca.call(ea, "name");
            O.enumPrototypes = ca.call(b, "prototype");
            O.nonEnumShadows = !/valueOf/.test(d);
            O.spliceObjects = (xb.call(c, 0, 1), !c[0]);
            O.unindexedChars = "xx" != "x"[0] + Object("x")[0];
          })(1, 0);

          var ja = function (a, b) {
            return function (c, d) {
              var e = c ? aa(c) : 0;
              if (!B(e)) return a(c, d);

              for (var f = b ? e : -1, g = y(c); (b ? f-- : ++f < e) && false !== d(g[f], f, g);) {
                ;
              }

              return c;
            };
          }(xa),
              db = function (a) {
            return function (b, c, d) {
              var e = y(b);
              d = d(b);

              for (var f = d.length, g = a ? f : -1; a ? g-- : ++g < f;) {
                var h = d[g];
                if (false === c(e[h], h, e)) break;
              }

              return b;
            };
          }(),
              aa = Ca("length"),
              sa = function (a, b) {
            return function (c, d, e) {
              d = Ea(d, e);

              if (t(c)) {
                a: {
                  e = c.length;

                  for (var f = b ? e : -1; b ? f-- : ++f < e;) {
                    if (d(c[f], f, c)) {
                      d = f;
                      break a;
                    }
                  }

                  d = -1;
                }

                return -1 < d ? c[d] : m;
              }

              return cb(c, d, a);
            };
          }(ja),
              Ta = function (a, b) {
            return function (c, d, e) {
              return typeof d == "function" && e === m && t(c) ? a(c, d) : b(c, ha(d, e, 3));
            };
          }(ga, ja),
              t = yb || function (a) {
            return C(a) && B(a.length) && A.call(a) == F;
          },
              Ua = function (a) {
            return Ma(function (b, c) {
              var d = -1,
                  e = null == b ? 0 : c.length,
                  f = 2 < e ? c[e - 2] : m,
                  g = 2 < e ? c[2] : m,
                  h = 1 < e ? c[e - 1] : m;
              typeof f == "function" ? (f = ha(f, h, 5), e -= 2) : (f = typeof h == "function" ? h : m, e -= f ? 1 : 0);
              g && Ja(c[0], c[1], g) && (f = 3 > e ? m : f, e = 1);

              for (; ++d < e;) {
                (g = c[d]) && a(b, g, f);
              }

              return b;
            });
          }(function (a, b, c) {
            if (c) for (var d = -1, e = D(b), f = e.length; ++d < f;) {
              var g = e[d],
                  h = a[g],
                  k = c(h, b[g], g, a, b);
              (k === k ? k === h : h !== h) && (h !== m || g in a) || (a[g] = k);
            } else a = ta(a, b);
            return a;
          }),
              D = Sa ? function (a) {
            var b = null == a ? m : a.constructor;
            return typeof b == "function" && b.prototype === a || (typeof a == "function" ? k.support.enumPrototypes : null != a && B(aa(a))) ? Ka(a) : x(a) ? Sa(a) : [];
          } : Ka;

          k.assign = Ua;
          k.callback = R;
          k.filter = qa;
          k.forEach = Ta;
          k.keys = D;
          k.keysIn = La;
          k.matches = Qa;
          k.pairs = Fa;
          k.property = va;
          k.restParam = Ma;

          k.where = function (a, b) {
            return qa(a, P(b));
          };

          k.each = Ta;
          k.extend = Ua;
          k.iteratee = R;
          k.select = qa;
          k.find = sa;

          k.findWhere = function (a, b) {
            return sa(a, P(b));
          };

          k.identity = ia;
          k.isArguments = pa;
          k.isArray = t;

          k.isFinite = function (a) {
            return typeof a == "number" && zb(a);
          };

          k.isFunction = da;
          k.isNative = Ha;
          k.isObject = x;
          k.isString = ba;
          k.isTypedArray = la;
          k.last = Ba;
          k.detect = sa;
          k.VERSION = "3.10.1";
          "function" == "function" && typeof __webpack_require__(
          /*! !webpack amd options */
          4) == "object" && __webpack_require__(
          /*! !webpack amd options */
          4) && !(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
            return k;
          }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
        }).call(this);
        /* WEBPACK VAR INJECTION */
      }).call(exports, __webpack_require__(
      /*! ./../~/webpack/buildin/module.js */
      3)(module), function () {
        return this;
      }());
      /***/
    },
    /* 3 */

    /*!***********************************!*\
      !*** (webpack)/buildin/module.js ***!
      \***********************************/

    /***/
    function (module, exports) {
      module.exports = function (module) {
        if (!module.webpackPolyfill) {
          module.deprecate = function () {};

          module.paths = []; // module.parent = undefined by default

          module.children = [];
          module.webpackPolyfill = 1;
        }

        return module;
      };
      /***/

    },
    /* 4 */

    /*!****************************************!*\
      !*** (webpack)/buildin/amd-options.js ***!
      \****************************************/

    /***/
    function (module, exports) {
      /* WEBPACK VAR INJECTION */
      (function (__webpack_amd_options__) {
        module.exports = __webpack_amd_options__;
        /* WEBPACK VAR INJECTION */
      }).call(exports, {});
      /***/
    },
    /* 5 */

    /*!**********************************!*\
      !*** ./src/angularMessageBus.ts ***!
      \**********************************/

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      var messageBus_1 = __webpack_require__(
      /*! ./messageBus */
      1);

      function createMessageBusService(angular) {
        angular.module('web.messageBus', []).factory('messageBus', ['$rootScope', '$timeout', function ($rootScope, $timeout) {
          //console.info('creating messageBus service');
          var msgBusService = {
            domains: [],
            listen: listen,
            send: send,
            ask: ask
          }; // copy msgBusService.domains to global messageBus

          $rootScope.$watch(function () {
            return msgBusService.domains;
          }, function (value) {
            messageBus_1.default.domains = value;
          }, true);
          return msgBusService;

          function listen() {
            if (arguments[1]) {
              var callback = arguments[1];

              arguments[1] = function () {
                $timeout(callback.apply({}, arguments));
              };
            }

            messageBus_1.default.listen.apply({}, arguments);
          }

          function send() {
            messageBus_1.default.send.apply({}, arguments);
          }

          function ask() {
            if (arguments[2]) {
              var callback = arguments[2];

              arguments[2] = function () {
                $timeout(callback.apply({}, arguments));
              };
            }

            messageBus_1.default.ask.apply({}, arguments);
          }
        }]);
      }

      exports.createMessageBusService = createMessageBusService;
      /***/
    }
    /******/
    ])
  );
});

;